import { Rank } from '../../sim/defs';
import { defineEnemy, Motion } from '../schema';

/** E-ORG2b — SPORE. La feuille du Couveur, et l'occupation du terrain.
 *
 *  Ce que sème le Couveur : une chose lente qui coule jusqu'au mi-bas du terrain,
 *  s'y installe et OSCILLE sans jamais repartir. Elle ne couve rien — c'est elle
 *  qui termine la chaîne Couveur → Spore et empêche l'engendrement de se propager
 *  sans fin.
 *
 *  ── Ce qu'elle enseigne ──
 *  Le prix de l'inaction en amont, mais sous une autre forme que la Larve. La
 *  Larve est une facture qui pique et s'en va ; la Spore est une facture qui
 *  RESTE. Une seule est anodine ; par quatre, installées en travers de la rangée
 *  basse, elles rognent l'espace d'esquive au moment précis où le joueur en a
 *  besoin pour le reste de la vague. On la crève d'un tir — mais chaque tir
 *  dépensé sur une spore est un tir qui ne part pas sur sa source.
 *
 *  ── Pourquoi elle ne pique pas et ne tire pas ──
 *  Sa menace est l'ENCOMBREMENT, pas la frappe. Un tir la rendrait redondante
 *  avec la Larve ; une descente franche la ferait sortir du cadre et dissoudrait
 *  le nuage qu'elle est censée épaissir. Elle flotte, elle gêne, elle attend
 *  qu'on s'en occupe — et c'est exactement ce qui donne son poids à la décision
 *  de trancher le Couveur tôt.
 *
 *  ── Télégraphe court ──
 *  0,4 s : elle est semée en plein combat, pas apparue du hors-champ ; le joueur
 *  l'a vue couler du Couveur. Un long télégraphe la rendrait intouchable pendant
 *  l'essentiel de sa descente et retirerait la fenêtre où on la crève avant
 *  qu'elle ne s'installe. */
export default defineEnemy({
  id: 'spore',
  rank: Rank.Popcorn,
  hp: 22,
  visualRadius: 14,
  score: 30,
  telegraph: 0.4,
  // Le butin tombe du Couveur. Récompenser aussi chaque spore doublerait la mise
  // d'un seul ennemi et fausserait l'économie.
  drops: 0,
  // Coule lentement jusqu'au mi-bas (holdY) puis se poste et oscille : elle
  // s'installe en travers de la rangée basse, sans jamais rejoindre le joueur.
  motion: { kind: Motion.Hover, speed: 75, amplitude: 70, frequency: 0.6, holdY: -100 },
});
